import { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const overlayStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Orbitron:wght@400;700;900&family=Oxanium:wght@400;600;700&display=swap');

  * { margin: 0; padding: 0; box-sizing: border-box; }

  body, html {
    background: transparent !important;
    overflow: hidden;
  }

  .obs-root {
    background: transparent;
    width: 380px;
    height: 520px;
    display: flex;
    flex-direction: column;
    font-family: 'Oxanium', sans-serif;
    color: #fff;
    border-radius: 12px;
    overflow: hidden;
    border: 1px solid rgba(0,212,255,0.25);
    box-shadow: 0 0 30px rgba(0,0,0,0.6);
  }

  .obs-header {
    background: linear-gradient(180deg, rgba(0,0,0,0.95) 0%, rgba(8,12,24,0.95) 100%);
    padding: 10px 14px;
    border-bottom: 1px solid rgba(0,212,255,0.3);
    flex-shrink: 0;
  }

  .obs-title {
    font-family: 'Orbitron', sans-serif;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 2px;
    color: #00d4ff;
    margin-bottom: 8px;
    text-align: center;
  }

  .obs-stats-row {
    display: flex;
    justify-content: space-between;
    gap: 4px;
  }

  .obs-stat {
    text-align: center;
    flex: 1;
  }

  .obs-stat-label {
    font-size: 8px;
    text-transform: uppercase;
    letter-spacing: 1px;
    color: rgba(255,255,255,0.4);
    font-weight: 600;
  }

  .obs-stat-value {
    font-size: 13px;
    font-weight: 700;
    font-family: 'Orbitron', sans-serif;
  }

  .obs-stat-value.cyan { color: #00d4ff; }
  .obs-stat-value.green { color: #4ade80; }
  .obs-stat-value.yellow { color: #fbbf24; }
  .obs-stat-value.purple { color: #c084fc; }

  .obs-progress-bar {
    height: 2px;
    background: rgba(255,255,255,0.06);
    flex-shrink: 0;
  }

  .obs-progress-fill {
    height: 100%;
    background: linear-gradient(90deg, #00d4ff, #0078ff);
    transition: width 0.5s ease;
  }

  .obs-scroll-area {
    flex: 1;
    overflow: hidden;
    position: relative;
    background: rgba(5,8,18,0.92);
  }

  .obs-scroll-track {
    display: flex;
    flex-direction: column;
    gap: 2px;
    padding: 4px 6px;
    animation: scrollUp var(--scroll-duration, 25s) linear infinite;
    will-change: transform;
  }

  @keyframes scrollUp {
    0% { transform: translateY(0); }
    100% { transform: translateY(-50%); }
  }

  .obs-slot {
    display: grid;
    grid-template-columns: 26px 1fr 52px 62px 48px;
    align-items: center;
    gap: 6px;
    padding: 5px 8px;
    border-radius: 6px;
    background: rgba(255,255,255,0.03);
    border: 1px solid rgba(255,255,255,0.04);
    min-height: 34px;
  }

  .obs-slot.opened {
    background: rgba(0,212,255,0.06);
    border-color: rgba(0,212,255,0.15);
  }

  .obs-slot.big-win {
    background: linear-gradient(90deg, rgba(250,204,21,0.1) 0%, rgba(250,204,21,0.03) 100%);
    border-color: rgba(250,204,21,0.3);
  }

  .obs-slot.current {
    background: linear-gradient(90deg, rgba(0,212,255,0.15) 0%, rgba(0,120,255,0.06) 100%);
    border-color: rgba(0,212,255,0.4);
    box-shadow: 0 0 12px rgba(0,212,255,0.1);
  }

  .obs-slot-num {
    font-size: 10px;
    font-weight: 700;
    color: rgba(255,255,255,0.3);
    text-align: center;
    font-family: 'Orbitron', sans-serif;
  }
  .obs-slot.opened .obs-slot-num,
  .obs-slot.current .obs-slot-num { color: #00d4ff; }
  .obs-slot.big-win .obs-slot-num { color: #fbbf24; }

  .obs-slot-name {
    font-size: 11px;
    font-weight: 600;
    color: #fff;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.2;
  }

  .obs-slot-provider {
    font-size: 8px;
    color: rgba(255,255,255,0.35);
  }

  .obs-slot-bet {
    font-size: 10px;
    color: rgba(255,255,255,0.5);
    text-align: right;
  }

  .obs-slot-win {
    font-size: 11px;
    font-weight: 700;
    text-align: right;
  }
  .obs-slot-win.pending { color: rgba(255,255,255,0.15); }
  .obs-slot-win.won { color: #4ade80; }
  .obs-slot-win.big { color: #fbbf24; }

  .obs-slot-multi {
    font-size: 10px;
    font-weight: 700;
    text-align: right;
    font-family: 'Orbitron', sans-serif;
  }
  .obs-slot-multi.pending { color: rgba(255,255,255,0.12); }
  .obs-slot-multi.low { color: #f87171; }
  .obs-slot-multi.mid { color: #fbbf24; }
  .obs-slot-multi.high { color: #4ade80; }
  .obs-slot-multi.mega { color: #c084fc; }

  .obs-no-data {
    width: 380px;
    height: 520px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-family: 'Orbitron', sans-serif;
    color: rgba(255,255,255,0.3);
    background: rgba(0,0,0,0.9);
    border-radius: 12px;
  }
`;

export default function OBSOverlay() {
  const { huntId } = useParams();
  const [hunt, setHunt] = useState(null);
  const [loading, setLoading] = useState(true);
  const scrollRef = useRef(null);

  useEffect(() => {
    fetchHunt();
    const interval = setInterval(fetchHunt, 5000);
    return () => clearInterval(interval);
  }, [huntId]);

  const fetchHunt = async () => {
    try {
      const response = await axios.get(`${API}/hunts/${huntId}`);
      setHunt(response.data);
    } catch (error) {
      console.error('Failed to fetch hunt:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading || !hunt) {
    return (
      <>
        <style>{overlayStyles}</style>
        <div className="obs-no-data" data-testid="obs-loading">
          {loading ? 'LOADING...' : 'NOT FOUND'}
        </div>
      </>
    );
  }

  const slots = hunt.slots || [];
  const totalWins = slots.reduce((sum, s) => sum + (s.win || 0), 0);
  const bestWin = slots.length > 0 ? Math.max(0, ...slots.map(s => s.win || 0)) : 0;
  const openedCount = hunt.opened_count || 0;
  const avgX = hunt.start_balance > 0 ? (totalWins / hunt.start_balance) : 0;
  const endBalance = (hunt.start_balance || 0) + totalWins;
  const progress = slots.length > 0 ? (openedCount / slots.length) * 100 : 0;

  const displaySlots = [...slots, ...slots];
  const scrollDuration = Math.max(15, slots.length * 2.5);

  const getMultiClass = (multi) => {
    if (!multi || multi === 0) return 'pending';
    if (multi < 2) return 'low';
    if (multi < 5) return 'mid';
    if (multi < 20) return 'high';
    return 'mega';
  };

  return (
    <>
      <style>{overlayStyles}</style>
      <div className="obs-root" data-testid="obs-overlay">
        {/* Header with stats */}
        <div className="obs-header">
          <div className="obs-title" data-testid="obs-title">Bonus Hunt</div>
          <div className="obs-stats-row" data-testid="obs-stats-bar">
            <div className="obs-stat">
              <div className="obs-stat-label">Start</div>
              <div className="obs-stat-value cyan">C${hunt.start_balance?.toLocaleString()}</div>
            </div>
            <div className="obs-stat">
              <div className="obs-stat-label">Current</div>
              <div className="obs-stat-value yellow">C${endBalance.toLocaleString()}</div>
            </div>
            <div className="obs-stat">
              <div className="obs-stat-label">Best</div>
              <div className="obs-stat-value green">C${bestWin.toLocaleString()}</div>
            </div>
            <div className="obs-stat">
              <div className="obs-stat-label">Avg X</div>
              <div className="obs-stat-value purple">{avgX.toFixed(2)}x</div>
            </div>
            <div className="obs-stat">
              <div className="obs-stat-label">Open</div>
              <div className="obs-stat-value cyan">{openedCount}/{slots.length}</div>
            </div>
          </div>
        </div>

        {/* Progress */}
        <div className="obs-progress-bar">
          <div className="obs-progress-fill" style={{ width: `${progress}%` }} />
        </div>

        {/* Scrolling Slots */}
        <div className="obs-scroll-area">
          <div
            ref={scrollRef}
            className="obs-scroll-track"
            style={{ '--scroll-duration': `${scrollDuration}s` }}
            data-testid="obs-scroll-track"
          >
            {displaySlots.map((slot, idx) => {
              const realIdx = idx % slots.length;
              const isOpened = slot.win > 0;
              const isBigWin = slot.multiplier >= 10;
              const isCurrent = realIdx === openedCount;

              let slotClass = 'obs-slot';
              if (isCurrent) slotClass += ' current';
              else if (isBigWin) slotClass += ' big-win';
              else if (isOpened) slotClass += ' opened';

              return (
                <div key={`${slot.slot_id || slot.name}-${idx}`} className={slotClass} data-testid={`obs-slot-${realIdx}`}>
                  <div className="obs-slot-num">{realIdx + 1}</div>
                  <div>
                    <div className="obs-slot-name">{slot.name}</div>
                    <div className="obs-slot-provider">{slot.provider}</div>
                  </div>
                  <div className="obs-slot-bet">C${slot.bet_size}</div>
                  <div className={`obs-slot-win ${isOpened ? (isBigWin ? 'big' : 'won') : 'pending'}`}>
                    {isOpened ? `C$${slot.win.toLocaleString()}` : '---'}
                  </div>
                  <div className={`obs-slot-multi ${getMultiClass(slot.multiplier)}`}>
                    {slot.multiplier > 0 ? `${slot.multiplier.toFixed(1)}x` : '---'}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
}
